import { createMediaButton } from "../create-media-button.js";
import { AirPlayButtonCore, AirPlayButtonDataAttrs } from "@videojs/core";
import { selectRemotePlayback } from "@videojs/core/dom";
//#region src/ui/airplay-button/component.tsx
/** A button that toggles AirPlay to a remote device. */
const AirPlayButton = createMediaButton({
	displayName: "AirPlayButton",
	core: AirPlayButtonCore,
	stateAttrMap: AirPlayButtonDataAttrs,
	selector: selectRemotePlayback,
	action: (core, state) => core.toggle(state),
	isSupported: (state) => !state.hidden
});
//#endregion
export { AirPlayButton };

//# sourceMappingURL=component.js.map